import { useState, useEffect, useCallback } from "react";
import userService from "../services/userService.js";

/**
 * useUserDetails
 * Charge toutes les données pertinentes pour un adhérent
 * @param {number|string} userId - ID de l'adhérent
 */
export function useUserDetails(userId) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch user data
  const fetchUserDetails = useCallback(async () => {
    if (!userId) {
      setError("User ID manquant");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const userData = await userService.getById(userId);
      if (!userData) throw new Error("Adhérent non trouvé");
      setUser(userData);
    } catch (err) {
      setError(err.message || "Erreur lors du chargement de l’adhérent");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  const reload = useCallback(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  return {
    user,
    loading,
    error,
    reload,
  };
}
